export default function Products() {
    return (
      <section className="products-section">
        <div className="header">
          <h1>Real tools for real life.</h1>
          <p className="intro-text">
            Our products are built through trusted partners and designed to fit your lifestyle:
          </p>
        </div>
  
        <div className="products-container">
          {/* BankVole App */}
          <div className="product-card">
            <h2 className="product-title">BankVole App</h2>
            <p className="product-description">
              Save, Invest & Grow. Through our partner Checkoff, BankVole helps you grow your money 
              with flexible savings and fixed deposit plans right from your phone.
            </p>
          </div>
  
          {/* TravelMoni */}
          <div className="product-card">
            <h2 className="product-title">TravelMoni</h2>
            <p className="product-description">
              Financial Support for Your Plans. Traveling, schooling abroad, securing a loan, or 
              building your business's financial statement? TravelMoni provides fast and reliable 
              financial documentation to help you succeed.
            </p>
          </div>
  
          {/* SmartPay */}
          <div className="product-card">
            <h2 className="product-title">SmartPay by PlusCredit</h2>
            <p className="product-description">
              Buy Samsung Devices in Easy Installments. Through Watu and Samsung, get the latest 
              phones now and pay monthly zero stress, full flex.
            </p>
          </div>
  
          {/* USD Fixed Deposit Management */}
          <div className="product-card">
            <h2 className="product-title">USD Fixed Deposit Management (FX FD)</h2>
            <p className="product-description">
              Secure Dollar Investments with High Returns. Lock in up to 8% p.a. returns with our 
              dollar fixed deposit option powered by our partners and managed with care.
            </p>
          </div>
        </div>
      </section>
    );
  }
  